import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../services/shared/app.service';
import { MenustateService } from '../../../services/shared/menustate.service';
import { TranslateService } from '@ngx-translate/core';
import { ConstantValues } from '../../../common/constant-values';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent implements OnInit {
  @Input() isCollapsed: boolean = false;
  @Input() IsMobileView: boolean = false;
  @Output() sidebarToggled = new EventEmitter<boolean>();

  systemLang: string = 'en';

  constructor(
    private router: Router, private menuStateService: MenustateService,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.translate.addLangs(['en', 'my']);
    this.translate.setDefaultLang('en');

    const lang = localStorage.getItem(ConstantValues.StaticValue.PMS_SYTSTEM_LANG);
    if (lang && lang.match(/en|my/)) {
      this.translate.use(lang);
      this.systemLang = lang; // Initialize systemLang with the stored value
    } else {
      const browserLang = this.translate.getBrowserLang();
      const defaultLang = browserLang?.match(/en|my/) ? browserLang : 'en';
      this.translate.use(defaultLang);
      this.systemLang = defaultLang; // Initialize systemLang with the default value
      localStorage.setItem(ConstantValues.StaticValue.PMS_SYTSTEM_LANG, this.systemLang);
    }
  }

  onChange(event: Event):void {
    this.changeLanguage(this.systemLang);
  }

  changeLanguage(lang: string) {
    this.systemLang = lang;
    this.translate.use(lang);
    localStorage.setItem(ConstantValues.StaticValue.PMS_SYTSTEM_LANG, lang);
  }

  logout() {
    this.menuStateService.resetMenuState();
    this.router.navigate(['login']);
  }

  localStorageItems: { key: string, value: string | null }[] = [];
  logLocalStorage() {
    const keys = Object.keys(localStorage);
    this.localStorageItems = keys.map(key => ({
      key,
      value: localStorage.getItem(key)
    }));
  }

   toggleSidebar() {
    this.sidebarToggled.emit(!this.isCollapsed); // Emit the new state
  }

}
